import React from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import { Query } from '@apollo/client/react/components';
import { Link } from 'react-router-dom';
import { fromGlobalId } from 'graphql-relay';
import { mapAfter } from 'apollo-relay/update-query';

import LoadingWrapperView from 'four-nets/ui/loaders/loading-wrapper-view';

import query, { HashtagsQuery, HashtagsQueryVariables } from './hashtags-loader.graphql';
import defaultStyles from './hashtags.scss';

export interface Props {
    styles: typeof defaultStyles;
    groupId?: string;
}

class Hashtags extends React.PureComponent<Props> {
    render() {
        const { styles, groupId } = this.props;
        let groupDjangoId;
        let href = '/blogs/?h=';
        if (groupId) {
            groupDjangoId = fromGlobalId(groupId).id;
            href = `/group/${groupDjangoId}/?h=`;
        }

        return (
            <div className={styles.wrapper}>
                <div className={styles.title}>
                    <FormattedMessage id='TAGGED_POSTS' />
                </div>
                <Query<HashtagsQuery, HashtagsQueryVariables>
                    query={query}
                    variables={{ groupId }}
                    fetchPolicy='cache-first'
                >
                    {({ data, loading, fetchMore }) => {
                        const recentCount =
                            data &&
                            data.mostRecentHashtags &&
                            data.mostRecentHashtags.edges &&
                            data.mostRecentHashtags.edges.length;
                        const pageInfo = data && data.mostPopularHashtags && data.mostPopularHashtags.pageInfo;

                        return (
                            <LoadingWrapperView loading={loading}>
                                <div className={styles.groupTitle}>
                                    <FormattedMessage id='HASHTAGS_NEWEST' />
                                </div>
                                <div className={styles.hashtagGroup}>
                                    {data &&
                                        data.mostRecentHashtags &&
                                        data.mostRecentHashtags.edges.map(hashtagEdge => {
                                            if (!hashtagEdge || !hashtagEdge.node) {
                                                return null;
                                            }
                                            const { id, hashtag, itemCount } = hashtagEdge.node!;

                                            return (
                                                <Link
                                                    to={`${href}${hashtag}`}
                                                    className={styles.link}
                                                    key={`recent_${id}`}
                                                >
                                                    <span className={styles.hashtag}>{`#${hashtag}`}</span>
                                                    <span className={styles.count}>({itemCount})</span>
                                                </Link>
                                            );
                                        })}
                                </div>
                                {recentCount && recentCount >= 5 ? (
                                    <React.Fragment>
                                        <div className={styles.groupTitle}>
                                            <FormattedMessage id='HASHTAGS_MOST_USED' />
                                        </div>
                                        <div className={styles.hashtagGroup}>
                                            {data &&
                                                data.mostPopularHashtags &&
                                                data.mostPopularHashtags.edges.map(hashtagEdge => {
                                                    if (!hashtagEdge || !hashtagEdge.node) {
                                                        return null;
                                                    }
                                                    const { id, hashtag, itemCount } = hashtagEdge.node!;

                                                    return (
                                                        <Link
                                                            to={`${href}${hashtag}`}
                                                            className={styles.link}
                                                            key={`popular_${id}`}
                                                        >
                                                            <span className={styles.hashtag}>{`#${hashtag}`}</span>
                                                            <span className={styles.count}>({itemCount})</span>
                                                        </Link>
                                                    );
                                                })}
                                        </div>
                                        {pageInfo && pageInfo.hasNextPage ? (
                                            <button
                                                className={styles.fetchMore}
                                                onClick={() => {
                                                    const endCursor = pageInfo.endCursor;

                                                    return fetchMore({
                                                        variables: { after: endCursor },
                                                        updateQuery: (
                                                            previousResult = {} as HashtagsQuery,
                                                            { fetchMoreResult = {} as HashtagsQuery }
                                                        ) => {
                                                            return {
                                                                ...previousResult,
                                                                mostPopularHashtags: mapAfter(
                                                                    previousResult.mostPopularHashtags,
                                                                    fetchMoreResult.mostPopularHashtags
                                                                ),
                                                            };
                                                        },
                                                    });
                                                }}
                                            >
                                                <FormattedMessage id='BUTTON_LOAD_MORE' />
                                            </button>
                                        ) : null}
                                    </React.Fragment>
                                ) : null}
                            </LoadingWrapperView>
                        );
                    }}
                </Query>
            </div>
        );
    }
}

export default Styled(defaultStyles)(Hashtags);
